import React, { Component } from 'react';
import './index.css';

class Row2 extends Component {
  constructor(props) {
    super(props);
    this.state = {

    }
  }


  render() {
    const _pdfInfo = this.props.pdfInfo ? this.props.pdfInfo : null;
    let userInfo = _pdfInfo ? _pdfInfo.userInfo : null;
    return (
      <div className='pdf-invoice-grid-row2'>
        <div className='pdf-invoice-grid-row2-side-header'>
          <div className='pdf-invoice-grid-row2-side-header-text'>{'مشخصات خریدار'}</div>
        </div>
        <div className='pdf-invoice-grid-row2-content'>
          <div className='pdf-invoice-grid-row2-content-wrapper'>
            <div className='pdf-invoice-grid-row2-content-cl1'>
              <div><b>نام شخص حقیقی/حقوقی</b>: {userInfo ? userInfo.name :''} </div>
              <div className='display-flex-row'>
                <div style={{ width: '220px' }}><b>نشانی کامل</b>: <b>استان</b>: {userInfo ? userInfo.city :''}</div>
                <div><b>شهرستان</b>: </div>
              </div>
              <div><b>نشانی</b>: {userInfo ? userInfo.address:''}</div>
            </div>
          
            <div className='pdf-invoice-grid-row2-content-cl2'>
              <div><b>شماره اقتصادی</b>: {userInfo ? userInfo.registrationNumber:''} </div>
              <div><b>کد پستی ۱۰ رقمی</b>: {userInfo ? userInfo.postalCode:''} </div>
              <div><b>تلفن</b>: {userInfo ? userInfo.phone:''}</div>
            </div>

            <div className='pdf-invoice-grid-row2-content-cl3'>
              <div><b>شماره ملی</b>: {userInfo ? userInfo.nationalNumber:''}</div>
              <div><b>شهر</b>: {userInfo ? userInfo.city:''}</div>
              <div><b>نمابر</b>: {userInfo ? userInfo.fax:''}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}




export default Row2;
